import {get, post, put} from '../../utils/ApiUtil';
import User from '../../models/User';
import Page from '../../filters/Page';

/**
 * ユーザーの一覧を取得
 *
 * @param filter
 * @returns {Promise<*>}
 */
export async function getUsers(filter) {
  const data = await get('/api/admin/users', filter);
  return data.map(u => new User(u));
}

/**
 * ユーザーの一覧を取得（ページネーション）
 *
 * @param filter
 * @returns {Promise<Page>}
 */
export async function getPaginatedUsers(filter) {
  const data = await get('/api/admin/users/paginated', filter);
  return new Page(data, User);
}

/**
 * ユーザーの詳細を取得
 *
 * @param id
 * @returns {Promise<User>}
 */
export async function getUser(id) {
  const data = await get('/api/admin/users/' + id);
  return new User(data);
}

/**
 * ユーザーを登録
 *
 * @param user
 * @returns {Promise<User>}
 */
export async function createUser(user) {
  const data = await post('/api/admin/users', user);
  return new User(data);
}

/**
 * ユーザーを更新
 *
 * @param user
 * @returns {Promise<User>}
 */
export async function updateUser(user) {
  const data = await put('/api/admin/users/' + user.id, user);
  return new User(data);
}
